<script>
  import { useLocation } from "svelte-routing";
  import MobileNavButton from "./MobileNavButton.svelte";
  import { onMount } from "svelte";
  import GalleryToolbar from "./GalleryToolbar.svelte";
  import {
    LINK_ABOUT,
    LINK_CREATE,
    LINK_EDITIONS,
    LINK_GALLERY,
    LINK_DONATE,
    LINK_HOME,
    PATH_CREATE,
    PATH_GALLERY,
    PATH_EDITIONS,
    PATH_DONATE,
    PATH_ABOUT,
  } from "../util/constants";
  import NavLogo from "./NavLogo.svelte";
  import { link } from "../util/anchor-link";
  import AudioOverlay from "./AudioOverlay.svelte";

  let locationStore = useLocation();

  export let toolbar = false;
  export let sticky = false;
  export let mobileNavOpen = false;

  let curPath;

  const links = [
    PATH_CREATE,
    PATH_GALLERY,
    PATH_EDITIONS,
    PATH_DONATE,
    PATH_ABOUT,
  ].map((link) => {
    return [link, link.replace(/^\//, "")];
  });

  const unsub = locationStore.subscribe((loc) => {
    mobileNavOpen = false;
    curPath = loc ? loc.pathname : "/";
  });
  onMount(() => {
    return unsub;
  });

  function activator(ev, href) {
    const linker = link(ev);
    const unsub = locationStore.subscribe((v) => {
      if (ev && v) {
        const loc = v.pathname;
        if (loc == href) {
          ev.classList.add("active");
        } else {
          ev.classList.remove("active");
        }
        // console.log();
        // if (loc == href) ev.classList.add("active");
        // else ev.classList.remove("active");
      }
    });
    return {
      destroy() {
        linker.destroy();
        unsub();
      },
    };
  }
</script>

<div class="nav-container" class:sticky>
  <nav>
    <div class="start-tools">
      <NavLogo />
      <AudioOverlay></AudioOverlay>
    </div>
    <div class="end-tools">
      {#if !mobileNavOpen}
        <!-- <AudioPlayer /> -->
      {/if}
      <div class="desktop-nav">
        {#each links as [href, name]}
          <a
            use:link
            class="nav-link noselect"
            class:active={curPath == href}
            {href}>{name}</a
          >
        {/each}
      </div>
      <div class="mobile-nav-button">
        <MobileNavButton
          open={false}
          on:click={(ev) => {
            ev.preventDefault();
            mobileNavOpen = true;
          }}
        ></MobileNavButton>
      </div>
    </div>
  </nav>

  {#if toolbar}
    <GalleryToolbar />
  {/if}

  {#if mobileNavOpen}
    <div class="mobile-nav-frame">
      <div class="mobile-nav-top">
        <NavLogo />
        <!-- <Button text="x" xsmall on:click={() => (mobileNavOpen = false)}
      ></Button> -->
        <MobileNavButton
          on:click={(ev) => {
            ev.preventDefault();
            mobileNavOpen = false;
          }}
          open={true}
        ></MobileNavButton>
      </div>

      <div class="mobile-nav">
        {#each links as [href, name]}
          <a
            use:link
            class="nav-link noselect"
            class:active={curPath == href}
            {href}>{name}</a
          >
        {/each}
      </div>
    </div>
  {/if}
</div>

<style>
  .nav-container.sticky {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    background: white;
    z-index: 900;
  }

  .nav-container {
    --nav-gutter: 20px;
    --nav-height: 46px;
  }
  nav {
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: 100%;
    height: var(--nav-height);
    /* padding: 12.5px 20px; */
    padding: 0;
    padding-left: 0px;
    font-size: 15px;
    font-weight: 400;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid black;
    overflow: hidden;
    flex-shrink: 0;
  }

  .end-tools,
  .start-tools {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
  .start-tools {
    justify-content: flex-start;
  }
  .desktop-nav {
    /* border-left: 1px solid black; */
    /* padding-left: 20px; */
    height: 100%;
    display: flex;
    flex-direction: row;
    gap: 40px;
    justify-content: flex-end;
    align-items: center;
    padding-right: var(--nav-gutter);
  }
  .mobile-nav-frame {
    position: fixed;
    font-size: 15px;
    font-weight: 400;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 90vh;
    background: white;
    box-shadow:
      0px 4px 0px black,
      4px 0px 0px black,
      4px 4px 0px black;
    z-index: 1000000;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .mobile-nav-top {
    flex-shrink: 0;
    padding: 0px;
    padding-left: 0px;
    display: flex;
    justify-content: space-between;
    height: var(--nav-height);
    box-sizing: border-box;
    align-items: center;
    border-bottom: 1px dashed black;
  }
  .mobile-nav {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: var(--nav-gutter);
    font-size: 18px;
    flex-shrink: 1;
    justify-content: flex-start;
    align-items: flex-start;
  }
  :global(.nav-logo) {
    /* letter-spacing: 1px;
    -webkit-user-drag: none;
    font-weight: bold; */
  }
  :global(.nav-link) {
    -webkit-user-drag: none;
    font-weight: 400;
  }

  :global(.nav-link) {
    text-transform: uppercase;
    position: relative;
    text-decoration: none;
  }
  /* :global(.nav-logo:hover) {
    text-decoration: initial;
  }
  :global(.nav-link:hover) {
    text-decoration: initial;
  } */
  :global(.nav-link.active) {
    cursor: default;
  }
  :global(.nav-link.active::after) {
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    height: 1px;
    background: black;
    content: " ";
  }

  .mobile-nav-button,
  .mobile-nav-frame {
    display: none;
  }

  .mobile-nav-button {
    height: 100%;
  }

  @media screen and (max-width: 720px) {
    .nav-container {
      position: sticky;
      top: 0;
      left: 0;
      width: 100%;
      background: white;
      z-index: 900;
    }
    nav {
      padding-right: 0;
    }
    .desktop-nav {
      display: none;
    }
    .mobile-nav-button {
      display: initial;
    }
    .mobile-nav-frame {
      display: initial;
    }
  }
</style>
